import { Article, Calendar, Clock, MapPinLine } from "@phosphor-icons/react";
import { IOrder } from "../../services/types";
import { formatPrice } from "../../utils/utils";
import { decimalToTime } from "components/common/DigitalTimePicker";

export default function OrderHistoryItem({ order }: { order: IOrder }) {
  return (
    <div className="orderHistoryItem">
      <div className="orderHistoryItemRight">
        <div className="orderHistoryItemRightAddress">
          <Article size={15} />
          {order.orderServices?.map((e, index) => (
            <span key={"orderAttribute" + index}>{e?.service?.title}</span>
          ))}
        </div>
        <div className="orderHistoryItemRightAddress">
          <Calendar size={15} />
          <span>{order.date}</span>
          <Clock size={15} />
          <span>
            {decimalToTime(order.fromTime).hour}:
            {decimalToTime(order.fromTime).minute}
          </span>
        </div>
      </div>
      <div className="orderHistoryItemLeft">
        <span>مبلغ فاکتور : </span>
        <span>{formatPrice(order.price + Number(order.transportation))}</span>
        <span>خالص دریافتی : </span>
        <span>
          {formatPrice(
            (order.price * order.workerPercent) / 100 +
              Number(order.transportation),
          )}
        </span>
      </div>
    </div>
  );
}
